import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = {
  key: 0,
  class: "p-error"
}
const _hoisted_3 = { class: "pt-1 mb-2 ml-3 block" }
const _hoisted_4 = { class: "search-input pb-1 mb-3 ml-3 flex" }

import { ref, watch, onMounted, toRefs } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';
import { useClinicianOrganizationStore } from '@/store';

type Clinician = {
  id: number;
  display_name: string;
};

type ErrorsType = {
  name?: string;
};

type ModeType = 'add' | 'edit';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminManageBuildingModal',
  props: {
    organizationId: {},
    mode: {},
    initialName: {},
    initialSelectedClinicians: {}
  },
  emits: [EMIT.CANCEL, EMIT.SAVE, EMIT.CLOSE, EMIT.EDIT],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { organizationId, mode, initialName, initialSelectedClinicians } = toRefs(props);

const organizationStore = useClinicianOrganizationStore();
const emit = __emit;
const visible = ref(true);
const errors = ref<ErrorsType>({});
const name = ref(initialName.value ?? '');
const selectedClinicians = ref<Clinician[]>(initialSelectedClinicians.value ?? []);
const filters = ref({
  global: { value: null, matchMode: 'contains' },
});

watch(visible, (val: boolean) => {
  if (!val) emit(EMIT.CANCEL);
});

const getIdArray = (arr: Clinician[] | number[]): number[] => arr.map((c) => (typeof c === 'object' ? c.id : c));

const validateForm = (): boolean => {
  errors.value = {};
  if (!name.value) errors.value.name = 'Building name is required.';
  return !errors.value.name;
};

const submit = async (): Promise<void> => {
  if (!validateForm()) return;

  if (mode.value === 'add') {
    emit(EMIT.SAVE, {
      name: name.value,
      attachClinicians: selectedClinicians.value.map((c) => c.id),
    });
  } else if (mode.value === 'edit') {
    const initialIds = getIdArray(initialSelectedClinicians.value ?? []);
    const currentIds = getIdArray(selectedClinicians.value);

    const attachClinicians = currentIds.filter((id) => !initialIds.includes(id));
    const detachClinicians = initialIds.filter((id) => !currentIds.includes(id));

    emit(EMIT.EDIT, {
      name: name.value,
      attachClinicians,
      detachClinicians,
    });
  }
};

onMounted(async () => {
  await organizationStore.getCliniciansForOrganizationRequest(organizationId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: _unref(mode) === 'edit' ? 'Edit Building' : 'Add Building',
    closable: true,
    draggable: false,
    class: "dialog__container"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit(_unref(EMIT).CANCEL)))
      }),
      _createVNode(_component_AppButton, {
        text: "Save",
        type: "primary",
        onClick: submit
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "required" }, "Building Name", -1)),
        _createVNode(_component_InputText, {
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          class: "w-full"
        }, null, 8, ["modelValue"]),
        (errors.value.name)
          ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(errors.value.name), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_DataTable, {
        selection: selectedClinicians.value,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((selectedClinicians).value = $event)),
        value: _unref(organizationStore).clinicians,
        loading: _unref(organizationStore).loading,
        "data-key": "id",
        "responsive-layout": "scroll",
        "sort-field": 'display_name',
        "sort-order": 1,
        filters: filters.value,
        "global-filter-fields": ['display_name']
      }, {
        header: _withCtx(() => [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(mode) === 'edit' ? 'Edit Service Providers' : 'Add Service Providers'), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IconField, { "icon-position": "left" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputIcon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      name: "search",
                      class: "text-lg"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputText, {
                  modelValue: filters.value.global.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.global.value) = $event)),
                  placeholder: "Search service provider"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            "selection-mode": "multiple",
            "header-style": "width:3rem"
          }),
          _createVNode(_component_Column, {
            field: "display_name",
            header: "Name",
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.display_name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selection", "value", "loading", "filters"])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})